import { Box, Tag } from '@chakra-ui/react'

import { NEW_TUTOR_SESSION_THRESHOLD } from '@/utils/constants'

import UserQ from '@/queries/UserQ'
import type { Query } from '@/client/query'

import LevelFlair from '@/components/Worlds/UI/Level/LevelFlair'
import type { AugmentedWorldLevel } from '@/components/Worlds/UI/Level/types'

type LegacyLevel = 'new-tutor' | 'founding-tutor'

export function TutorProfileTag({ tutor }: { tutor: Query }): JSX.Element | null {
  const isUserTutor = tutor(UserQ.hasTutorRole()) ?? true
  const isUserAdmin = tutor(UserQ.hasSuperAdminRole()) ?? false

  const pastSessionCount =
    tutor(UserQ.countPastHostedSessionsIncludingMigrated({ requireLearnerAttendance: true })) ?? 0
  const isNewTutor = pastSessionCount < NEW_TUTOR_SESSION_THRESHOLD
  const isFoundingTutor = tutor(UserQ.hasFoundingTutorRole()) ?? false
  const isMentor = tutor(UserQ.hasMentorRole()) ?? false

  let level: AugmentedWorldLevel | LegacyLevel | null = null

  if (isUserAdmin) {
    level = 'admin'
  } else if (isUserTutor) {
    level = isNewTutor
      ? 'new-tutor'
      : isMentor
        ? 'coach'
        : isFoundingTutor
          ? 'founding-tutor'
          : 'tutor'
  }

  if (level == null) {
    return null
  }

  // Check for legacy levels
  if (level === 'new-tutor' || level === 'founding-tutor') {
    return (
      <Box
        pt={0}
        whiteSpace="nowrap"
        flexGrow={1}
        display="flex"
        justifyContent={['center', 'left']}
      >
        {level === 'new-tutor' ? (
          <Tag fontSize="14px" bg="blue.subtle" color="blue.fg">
            NEW TUTOR
          </Tag>
        ) : (
          <Tag fontSize="14px" bg="green.subtle" color="green.fg">
            FOUNDING TUTOR
          </Tag>
        )}
      </Box>
    )
  }

  return <LevelFlair level={level} />
}
